export const socketConnection = {
    path: '/refinement/socket',
    reconnection: true,
    transports: ['websocket', 'polling'],
    reconnectionAttempts: 5,
    withCredentials: true
}